import React from 'react';
import { PackageIcon } from 'lucide-react';
import { volumes } from '../data/content';
import { toneAt } from '../utils/iconTones';
import { Accent, SectionHeading } from './SectionHeading';
export function VolumesSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 pt-4 sm:pb-16" aria-labelledby="volumenes-titulo" data-id="element-193" data-mp="cnzclbimorbd">
      <div className="mx-auto max-w-5xl" data-id="element-194" data-mp="7q7l2ilwb77p">
        <SectionHeading id="volumenes-titulo" badge="Los 6 volúmenes del Kit" badgeIcon={PackageIcon} title={<>
              Cobertura Técnica Integral de <Accent data-id="element-196" data-mp="3c57da2yvh1vc">la Automatización Moderna</Accent>
            </>} subtitle="6 volúmenes digitales con base científica, protocolos de laboratorio y diagramación técnica, listos para tu clase." data-id="element-195" data-mp="3g4yaopiwmg8u" />

        <ol className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-197" data-mp="3l2rgvik7ja94">
          {volumes.map(({
          icon: Icon,
          number,
          title,
          description
        }, index) => <li key={number} className="flex h-full gap-2.5 rounded-lg border border-cream-300/70 bg-cream-50 p-3 transition-colors duration-150 ease-out hover:border-ember-400/60" data-id="element-198" data-mp="2selsmlty334j" data-mpi={index}>
              <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md ${toneAt(index).bg}`} data-id="element-199" data-mp="2edtnh17j4alx">
                <Icon className={`h-3 w-3 ${toneAt(index).fg}`} aria-hidden="true" data-id="element-200" data-mp="2j6mu5umk5t0n" />
              </span>
              <div className="min-w-0" data-id="element-201" data-mp="2o3vcpwbmbz2f">
                <h3 className="text-[0.8rem] font-semibold leading-tight text-forest-800" data-id="element-202" data-mp="1qgmldkoxrvsi">
                  <span className="text-forest-400" data-id="element-203" data-mp="1qiz788xteqau">V{number}.</span> {title}
                </h3>
                <p className="mt-1 text-[0.72rem] leading-snug text-forest-700/65" data-id="element-204" data-mp="1vhka6g4gbo2z">{description}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}